<script setup>
  import { computed } from 'vue';
  import { useSheetController } from '@/composables/useSheetsController';
  import ControlButton from "@/components/controls/ControlButton.vue";

  const emit = defineEmits(['mapButton:click']);

  const props = defineProps({
    type: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  });

  const classObject = computed(() => ({
    selected: useSheetController.sheets[props.type]?.open && useSheetController.sheets[props.type].content === props.content,
  }));

  function handleCick() {
    useSheetController.toggleSheet(props.type, props.content);

    emit('mapButton:click', props.content);
  }

</script>

<template>
  <ControlButton 
    @click.prevent="handleCick"
    :class="classObject">
    <slot></slot>
  </ControlButton>
</template>